import {useState} from "react";
import TotalCard from "../cards/total.card";
import EditPanel from "components/edit/edit.panel";
import OverviewCard from "../cards/overview.card";
import BottomDrawer from "components/drawers/bottom.drawer";

const OverviewPanel = () => {
  // NEW ITEM DEFAULT VALUES
  const newAsset = {
    name: "",
    description: "",
    classification: "",
    ownership: 100,
    include_networth: true,
    updated: "",
  };

  const newLiability = {
    name: "",
    description: "",
    classification: "",
    ownership: 100,
    include_networth: true,
    updated: "",
    being_repaid: true,
  };

  const [isEditing, setIsEditing] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [editingIsAsset, setEditingIsAsset] = useState(null);

  const editEntry = (item, isAsset) => {
    setIsEditing(true);
    setEditingItem(item);
    setEditingIsAsset(isAsset);
  };

  const cancelEntry = () => {
    setIsEditing(false);
    setEditingItem(null);
    setEditingIsAsset(null);
  };

  const openNewAsset = () => {
    setEditingIsAsset(true);
    setEditingItem(null);
    setIsEditing(true);
  };

  const openNewLiability = () => {
    setEditingIsAsset(false);
    setEditingItem(null);
    setIsEditing(true);
  };

  return (
    <>
      {/* ASSETS SECTION */}
      <div className="Assets light">
        <div className="Header" />
        <div className="flex col large-gap">
          <div className="flex row space center">
            <p className="xlarge padding">Assets</p>
            <button className="New button medium" onClick={openNewAsset}> New Asset </button>
          </div>

          <TotalCard isAsset onClick={openNewAsset} />
          <OverviewCard isAsset editEntry={(item) => editEntry(item, true)} onAddClick={openNewAsset} />
        </div>
      </div>

      {/* LIABILITIES SECTION */}

      <div className="Liabilities light">
        <div className="flex col large-gap">
          <div className="flex row space center">
            <p className="xlarge padding">Liabilities</p>
            <button className="New button medium" onClick={openNewLiability}>New Liability</button>
          </div>

          <TotalCard isLiability onClick={openNewLiability} />
          <OverviewCard isLiability editEntry={(item) => editEntry(item, false)} onAddClick={openNewLiability} />
        </div>
      </div>

      {/* EDITING MODAL */}
      {isEditing && (
        <BottomDrawer onCancel={cancelEntry}>
          <EditPanel isAsset={editingIsAsset} isNew={editingItem === null} item={editingItem === null ? (editingIsAsset ? newAsset : newLiability) : editingItem} onCancelHandler={cancelEntry} />
        </BottomDrawer>
      )}
    </>
  );
};

export default OverviewPanel;
